import { sdkSegmentConditions } from './sdk/index';
import { webSegmentConditions } from './web/index';
export const segmentConditions = {
    web: webSegmentConditions,
    sdk: sdkSegmentConditions,
};
//# sourceMappingURL=segment-conditions.js.map